import { Outlet, useLocation } from "react-router-dom";

/** Settings menu paths. Open with project_settings even without company-management. */
const PROJECT_SETTINGS_PREFIXES = [
    '/apps/company-management/offer',
    '/apps/company-management/pages',
    '/apps/company-management/support',
    '/apps/company-management/project_config',
]

const isProjectSettingsPath = (pathname) =>
    PROJECT_SETTINGS_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )

const AuthRole = ({ module, moudles }) => {
    const { pathname } = useLocation()
    const allowedModules = Array.isArray(module) ? module : [module]
    const hasAccess = allowedModules.some((item) => moudles?.includes(item))
    const settingsAccess = !hasAccess
        && allowedModules.includes('company-management')
        && moudles?.includes('project_settings')
        && isProjectSettingsPath(pathname)

    if (!hasAccess && !settingsAccess) {
        return null
    }
    return <Outlet />
}

export default AuthRole;
